module.exports = __webpack_public_path__ + "static/media/respiratory-disease.35f3e3ac.png";